import { DownloadIcon } from "@chakra-ui/icons";
import {
  Button,
  Modal,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  useDisclosure, useToast,
} from "@chakra-ui/react";
import {useMutation, useQueryClient} from "react-query";

import {requestAnswersExcel, requestAnswersSpeechace} from "../../shared/Api";
import {errorToast, successToast} from "../../shared/helper/ToastHelper";
import {CandidateFilterParams} from "../../shared/model/Dto";
import {adminKeys} from "../../shared/QueryKeys";
import {saveByteArray} from "../../shared/Utils";

const DownloadAnswers = (props: CandidateFilterParams ) => {
  const toast = useToast();
  const queryClient = useQueryClient();
  const { isOpen, onOpen, onClose } = useDisclosure();

  const downloadAnswerExcel = useMutation(()=>requestAnswersExcel(props), {
    onSuccess: (TData) => {
      successToast(toast, "Descargando respuestas");
      saveByteArray("Answers "+props.testName+" "+props.startDateValue, TData.data);
      return queryClient.invalidateQueries(adminKeys.candidateAnswers());
    },
    onError: () => {
      errorToast(toast, "Error descargando respuestas");
    },
  });

  const downloadAnswersSpeechace = useMutation(()=>requestAnswersSpeechace(props), {
    onSuccess: (TData) => {
      successToast(toast, "Descargando respuestas");
      saveByteArray("Answers Speechace"+props.testName+" "+props.startDateValue, TData.data);
      return queryClient.invalidateQueries(adminKeys.candidateAnswers());
    },
    onError: () => {
      errorToast(toast, "Error descargando respuestas");
    },
  });

  /*
  const downloadDataJson = useMutation(()=>requestDataJson(props), {
    onSuccess: (TData) => {
      successToast(toast, "Descargando respuestas");
      saveToTxt("data", TData.data);
      return queryClient.invalidateQueries(adminKeys.candidates());
    },
    onError: () => {
      errorToast(toast, "Error descargando respuestas");
    },
  });


  const exportAnswers = useMutation(()=>requestExportAnswers(props), {
    onSuccess: (TData) => {
      successToast(toast, "Exportando respuestas");
      saveByteArray("Respuestas", TData.data);
      return queryClient.invalidateQueries(adminKeys.candidates());
    },
    onError: () => {
      errorToast(toast, "Error exportando respuestas");
    },
  });*/

  return (
      <>
        <Button leftIcon={<DownloadIcon />} colorScheme="teal" onClick={onOpen}>
          Ver respuestas
        </Button>
        <Modal blockScrollOnMount={false} isOpen={isOpen} onClose={onClose}>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Descargar respuestas</ModalHeader>
            <ModalCloseButton />
            <ModalFooter>
              { ! props.isTeacher && <Button
                marginX={10}
                colorScheme="teal"
                type="submit"
                onClick={()=>downloadAnswerExcel.mutate()}
              >
                Reading y Listening
              </Button>
              }
              { ! props.isTeacher && <Button
                colorScheme="teal"
                type="submit"
                onClick={()=>downloadAnswersSpeechace.mutate()} >
                Speechace
              </Button>
              }
              {/* ! props.isTeacher && <Button
                marginX={10}
                colorScheme="teal"
                type="submit"
                onClick={()=>downloadDataJson.mutate()}
              >
                Formato Json
              </Button> }
              <Button
                colorScheme="teal"
                type="submit"
                onClick={()=>exportAnswers.mutate()}
              >
                Query txt
              </Button>*/}
            </ModalFooter>
          </ModalContent>
        </Modal>
      </>
  );
};

export default DownloadAnswers;
